import React from "react";
import { map } from "lodash";
import styles from "./Tab.module.scss";
import cx from "classnames";
const View = ({ name = "", defaultActiveKey, items }: any) => {
  const [activeKey, $activeKey] = React.useState(defaultActiveKey);
  const handler = {
    onClickTab: (item: any) => {
      if (item.key !== activeKey) {
        $activeKey(item.key);
      }
    },
  };
  return (
    <section className={styles.tabs}>
      <div className={styles.head}>
        {map(items, (item: any, index: number) => (
          <div
            onClick={() => handler.onClickTab(item)}
            className={cx(styles.tab, {
              [styles.active]: activeKey === item.key,
            })}
            key={`tab_${name ? name + "_" : name}${index}`}
          >
            <span>{item.label}</span>
          </div>
        ))}
      </div>
      <div className={styles.tabContent}>
        {map(items, (item: any, index: number) => (
          <div
            className={cx(styles.content, {
              [styles.active]: activeKey === item.key,
            })}
            key={`tab_content${name ? name + "_" : name}${index}`}
          >
            {item.children}
          </div>
        ))}
      </div>
    </section>
  );
};
export default View;
